import type { Resource } from '../../';
export const giftcard_cart_total: Resource = {"default":"Total"};
